module.exports = __webpack_public_path__ + "static/media/eversource.874c13c7.svg";